var formatTrackNumber = function formatTrackNumber(trackNumber) {
  var _trackNumber$toString;
  return (_trackNumber$toString = trackNumber === null || trackNumber === void 0 ? void 0 : trackNumber.toString().padStart(2, '0')) !== null && _trackNumber$toString !== void 0 ? _trackNumber$toString : '';
};
export default formatTrackNumber;